import React from 'react'
import { twMerge } from 'tailwind-merge'

export type ToolbarRadioOption<T> = {
  label: string
  value: T
}

type ToolbarRadioGroupProps<T> = {
  options: ToolbarRadioOption<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

/* TODO: it's not from our design system, we should ask designers to replace it with
 * the ui-lib radio component (src/editor/shared/ui-lib/radio.tsx)*/
/** @deprecated */
export const ToolbarRadioGroup = <T extends string>({
  options,
  value,
  onChange,
  className = '',
}: ToolbarRadioGroupProps<T>) => {
  return (
    <div className={twMerge('flex items-center gap-6" space-x-6', className)}>
      {options.map(option => (
        <label
          key={option.value}
          className="flex cursor-pointer items-center gap-3 text-L"
          onClick={() => onChange(option.value)}
        >
          <input
            type="radio"
            name="radio-group"
            value={option.value}
            checked={value === option.value}
            className="peer sr-only"
          />
          <div
            className={twMerge(
              'flex h-4 w-4 items-center justify-center rounded-full border border-borderInteractive bg-opacity-10',
              value === option.value && 'bg-bgSecondary',
            )}
          >
            {value === option.value && (
              <div className="h-2 w-2 rounded-full bg-iconPrimary" />
            )}
          </div>
          <span className="text-textPrimary">{option.label}</span>
        </label>
      ))}
    </div>
  )
}
